import React from 'react';

const UserContractContext = React.createContext(null);

export default UserContractContext;
